import Fragment from "./fragment";
import { teamReducer } from "../../../storage/reducers";
import FragmentSummary from "./fragment-summary";

export default class GameStart extends Fragment {
    constructor(tossWinner, offenseTeam) {
        super();
        this.tossWinner = tossWinner;
        this.offenseTeam = offenseTeam;

        this.requiredData = [
            {
                name: "tossWinner"
            },
            {
                name: "offenseTeam"
            }
        ];
    }

    summarize(summaryContext) {
        return new FragmentSummary("Game Start");
    }

    toJSON() {
        return {
            ...super.toJSON(),
            tossWinner: teamReducer(this.tossWinner),
            offenseTeam: teamReducer(this.offenseTeam)
        };
    }
}
